import { render, staticRenderFns } from "./domain__form.vue?vue&type=template&id=073655de"
import script from "./domain__form.vue?vue&type=script&lang=js"
export * from "./domain__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports